import React from "react";
import { useSubmissionsBuilderContext } from "../../SubmissionsBuilderContext";
import { FieldsList } from "./FieldsList";
import { ModulesList } from "./ModulesList";

export function FieldsTab() {
  const { existingSubmissionType } = useSubmissionsBuilderContext();

  return (
    <>
      <FieldsList atFieldPath={[]} />
      {!existingSubmissionType && <ModulesList />}
    </>
  );
}
